var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 37,
    viewBox: "0 0 65 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51246 18.1108L0.513181 36.1087H32.5093L26.5101 18.1108L6.51246 18.1108Z",
    fill: "#F3D55B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5115 26.1099L0.513181 36.1087H32.5093L26.5101 18.1108L14.5115 26.1099Z",
    fill: "#F0C419"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5086 18.1108L32.5093 36.1087H64.5054L58.5061 18.1108L38.5086 18.1108Z",
    fill: "#F3D55B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5076 26.1099L32.5093 36.1087H64.5054L58.5061 18.1108L46.5076 26.1099Z",
    fill: "#F0C419"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5105 0.112793L16.5112 18.1106L48.5074 18.1106L42.5081 0.112793L22.5105 0.112793Z",
    fill: "#F3D55B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5095 8.11183L16.5112 18.1106L48.5074 18.1106L42.5081 0.112793L30.5095 8.11183Z",
    fill: "#F0C419"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGold);
export default __webpack_public_path__ + "static/media/ic_gold.068e3893.svg";
export { ForwardRef as ReactComponent };